// extracted by mini-css-extract-plugin
export default {"highlighted-title":"HighlightedTitle_highlighted-title__RhmVr"};